import Function01 from "../img/Products/HRTraining/1.png";
import Function02 from "../img/Products/HRTraining/2.png";
import Function03 from "../img/Products/HRTraining/3.png";
import Function04 from "../img/Products/HRTraining/4.png";
import Function05 from "../img/Products/HRTraining/5.png";
import Function06 from "../img/Products/HRTraining/6.png";

export const TabGroup = [{label:"招募培訓管理",value:"Hr"}]

const HRTraining = [
    {tabGroup:["Hr"],systems:[{src:Function01,width:"100%",height:"100%",text:"系統目的"},{src:Function02,width:"100%",height:"100%",text:"系統架構"}]},
    {tabGroup:["Hr"],systems:[{src:Function03,width:"100%",height:"100%",text:"系統作業範圍"},{src:Function04,width:"100%",height:"100%",text:"系統特色"}]},
    {tabGroup:["Hr"],systems:[{src:Function05,width:"100%",height:"100%",text:"系統特色"},{src:Function06,width:"100%",height:"100%",text:"功能架構"}]},
];

export default HRTraining;